import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import toast, { Toaster } from "react-hot-toast";
import { ROUTE_PATHS } from "../../../../constants/routeConstants";
import { useSubscribeMutation } from "../../../../stores/api/subscribers.api";
import { CompanyLogo } from "../../../../Components/Utils";
import Effects from "../Effects";
import "./Footer.css";

const ArrowUpRight = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="7" y1="17" x2="17" y2="7" />
    <polyline points="7 7 17 7 17 17" />
  </svg>
);

const ArrowUp = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="18 15 12 9 6 15" />
  </svg>
);

/* Social icons */
const FacebookIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);
const TwitterXIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
const InstagramIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);
const PinterestIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
  </svg>
);
const WhatsAppIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);
const LinkedInIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);
const GitHubIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
  </svg>
);

const SOCIAL_ICON_MAP = {
  facebook:  { Icon: FacebookIcon,  color: "text-blue-400", border: "border-blue-900/50 hover:border-blue-400", bg: "hover:bg-blue-500/10" },
  instagram: { Icon: InstagramIcon, color: "text-blue-400", border: "border-blue-900/50 hover:border-blue-400", bg: "hover:bg-blue-500/10" },
  whatsapp:  { Icon: WhatsAppIcon,  color: "text-blue-400", border: "border-blue-900/50 hover:border-blue-400", bg: "hover:bg-blue-500/10" },
  x:         { Icon: TwitterXIcon,  color: "text-blue-400", border: "border-blue-900/50 hover:border-blue-400", bg: "hover:bg-blue-500/10" },
  linkedin:  { Icon: LinkedInIcon,  color: "text-blue-400", border: "border-blue-900/50 hover:border-blue-400", bg: "hover:bg-blue-500/10" },
  github:    { Icon: GitHubIcon,    color: "text-blue-400", border: "border-blue-900/50 hover:border-blue-400", bg: "hover:bg-blue-500/10" },
  pinterest: { Icon: PinterestIcon, color: "text-blue-400", border: "border-blue-900/50 hover:border-blue-400", bg: "hover:bg-blue-500/10" },
};

export const Footer = ({ description, socialLinks = [], contact }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [subscribe, { isLoading }] = useSubscribeMutation();
  const [aboutOpen, setAboutOpen] = useState(false);
  const aboutDescription = useMemo(() => {
    if (!description) return "";
    // Website settings can contain rich text from the admin editor.
    // Extract readable paragraphs without rendering untrusted HTML.
    const document = new DOMParser().parseFromString(description, "text/html");
    document.querySelectorAll("script, style").forEach((node) => node.remove());
    document.querySelectorAll("p, div, h1, h2, h3, h4, h5, h6, li, br").forEach((node) => {
      node.append(document.createTextNode("\n"));
    });
    return (document.body.textContent || "").trim();
  }, [description]);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const onSubscribe = async (data) => {
    try {
      await subscribe({ email: data.email }).unwrap();
      toast.success("Subscribed successfully!");
      reset();
    } catch {
      toast.error("Subscription failed. Please try again.");
    }
  };

  return (
    <footer className="enterprise-footer relative text-slate-300 overflow-hidden">
      {/* Subtle Pattern & Background Gradient Overlay */}

      <div className="absolute inset-0 bg-gradient-to-b from-blue-950/20 via-transparent to-black/60 pointer-events-none" />

      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />

      {/* Top Blue Glow Border Line */}
      <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-blue-600/40 to-transparent" />


      <div className="ef-container relative z-10">
        <div className="ef-intro"><div><p className="ef-eyebrow">YOUR PARTNER IN POSSIBILITY</p><h2>Built on trust<span>.</span><br/>Ready to help<span>.</span></h2></div><div><p className="ef-intro-copy">The right supplies. The right expertise.<br/>Let's move your business forward.</p><Link to={ROUTE_PATHS.CONTACT} onClick={scrollToTop} className="ef-button">Talk to our team <ArrowUpRight /></Link></div></div>
        <div className="ef-grid">
          <div className="ef-brand">
            <Link to={ROUTE_PATHS.HOME} onClick={scrollToTop} aria-label="Ukasha Enterprises home">
              <CompanyLogo variant="footer" className="h-[135px]  max-h-none w-auto max-w-none object-contain" />
            </Link>
            {aboutDescription && (
              <div className="ef-about">
                <h3>About Us<span>.</span></h3>
                <p className="ef-description">{aboutDescription}</p>
                <button type="button" className="ef-more" aria-haspopup="dialog" onClick={() => setAboutOpen(true)}>
                  Read more <ArrowUpRight />
                </button>
              </div>
            )}
          </div>
          {[
            {title:"Discover",links:[["Products",ROUTE_PATHS.PRODUCTS],["Categories",ROUTE_PATHS.CATEGORIES],["Our Brands",ROUTE_PATHS.BRANDS],["Blog",ROUTE_PATHS.BLOG]]},
            {title:"Company",links:[["About Us",ROUTE_PATHS.ABOUT],["Business Profile",ROUTE_PATHS.BUSINESS_PROFILE],["Contact Us",ROUTE_PATHS.CONTACT],["FAQs",ROUTE_PATHS.FAQ]]}
          ].map(({title,links}) => <nav key={title} aria-label={`Footer ${title}`} className="ef-nav"><h3>{title}</h3><ul>{links.map(([label,href])=><li key={label}><Link to={href} onClick={scrollToTop}>{label}</Link></li>)}</ul></nav>)}
          <div className="ef-contact"><h3>Need assistance?</h3>            <div className="space-y-2 pt-1 text-sm text-slate-400">
              {contact?.address ? (
                <a
                  href={`https://maps.google.com/?q=${encodeURIComponent(contact.address)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-2 hover:text-blue-300 transition-colors justify-center sm:justify-start"
                >
                  <svg className="flex-shrink-0 mt-0.5 text-blue-500" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                  </svg>
                  <span>{contact.address}</span>
                </a>
              ) : <div className="h-4 w-48 rounded bg-slate-900 animate-pulse" />}

              {contact?.email ? (
                <a
                  href={`mailto:${contact.email}`}
                  className="flex items-center gap-2 hover:text-blue-300 transition-colors justify-center sm:justify-start"
                >
                  <svg className="flex-shrink-0 text-blue-500" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                  </svg>
                  <span>{contact.email}</span>
                </a>
              ) : <div className="h-4 w-40 rounded bg-slate-900 animate-pulse" />}

              {contact?.phone ? (
                <a
                  href={`tel:${contact.phone}`}
                  className="flex items-center gap-2 hover:text-blue-300 transition-colors justify-center sm:justify-start"
                >
                  <svg className="flex-shrink-0 text-blue-500" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.1 19.79 19.79 0 0 1 1.59 4.5 2 2 0 0 1 3.56 2.33h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.18 6.18l.9-.9a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 17.5z"/>
                  </svg>
                  <span>{contact.phone}</span>
                </a>
              ) : <div className="h-4 w-32 rounded bg-slate-900 animate-pulse" />}
            </div>



<Link to={ROUTE_PATHS.CONTACT} onClick={scrollToTop} className="ef-more">Contact our team <ArrowUpRight /></Link></div>
        </div>
        <section className="ef-newsletter" aria-labelledby="footer-newsletter-title"><div className="ef-newsletter-copy"><div className="ef-envelope" aria-hidden="true"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 5 10 8L22 5"/></svg></div><div><h3 id="footer-newsletter-title">Stay informed<span>.</span></h3><p>New arrivals, industry updates and more. Straight to your inbox.</p></div></div><div className="ef-form">              <form
                className="flex flex-col gap-1"
                onSubmit={handleSubmit(onSubscribe)}
                noValidate
              >
                <div className="flex rounded bg-slate-950 border border-blue-900/60 focus-within:border-blue-500 transition-colors">
                  <input
                    type="email"
                    aria-label="Email address" autoComplete="email" aria-invalid={!!errors.email} placeholder="Enter your email address"
                    className="flex-1 min-w-0 px-4 py-2.5 text-sm bg-transparent text-slate-100 placeholder-slate-500 outline-none"
                    {...register("email", {
                      required: true,
                      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    })}
                  />
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="flex-shrink-0 bg-blue-600 hover:bg-blue-500 text-white px-4 py-2.5 text-sm font-medium transition-colors flex items-center gap-1.5 whitespace-nowrap disabled:opacity-60"
                  >
                    {isLoading ? "Subscribing..." : "Subscribe"} <ArrowUpRight />
                  </button>
                </div>
                {errors.email && (
                  <p className="text-xs text-blue-400 mt-1">Enter a valid email address.</p>
                )}
              </form></div></section>
        <div className="ef-bottom"><p>&copy; {new Date().getFullYear()} Ukasha Enterprises. All rights reserved.</p><nav aria-label="Legal"><Link to={ROUTE_PATHS.PRIVACY_POLICY} onClick={scrollToTop}>Privacy Policy</Link><Link to={ROUTE_PATHS.TERMS} onClick={scrollToTop}>Terms &amp; Conditions</Link></nav>            {/* Social Links */}
            {socialLinks.length > 0 && (
              <div className="flex items-center gap-2 pt-2 justify-center sm:justify-start">
                {socialLinks.map((link) => {
                  const entry = SOCIAL_ICON_MAP[link.type];
                  if (!entry) return null;
                  const { Icon, color, border, bg } = entry;
                  return (
                    <a
                      key={link.type}
                      href={link.url || "/"}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={link.type}
                      className={`w-8 h-8 rounded-full border bg-slate-950 flex items-center justify-center transition-all duration-300 ${color} ${border} ${bg}`}
                    >
                      <Icon />
                    </a>
                  );
                })}
              </div>
            )}
</div>
      </div>
      {/* Scroll To Top Button */}
      <button
        onClick={scrollToTop}
        className="hidden sm:flex fixed bottom-6 right-6 w-10 h-10 bg-slate-950 border border-blue-900/60 text-blue-400 hover:bg-blue-600 hover:text-white rounded-full shadow-2xl items-center justify-center transition-all z-40"
        aria-label="Scroll to top"
      >
        <ArrowUp />
      </button>

      {/* Mobile Bottom Navigation Bar */}
      <nav className="sm:hidden fixed bottom-0 left-0 right-0 bg-[#030712] border-t border-blue-950/80 z-50 flex items-stretch">
        {[
          {
            label: "Home",
            href: ROUTE_PATHS.HOME,
            icon: (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            ),
          },
          {
            label: "Products",
            href: ROUTE_PATHS.PRODUCTS,
            icon: (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" />
              </svg>
            ),
          },
          {
            label: "Blogs",
            href: ROUTE_PATHS.BLOG,
            icon: (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
              </svg>
            ),
          },
          {
            label: "Brands",
            href: ROUTE_PATHS.BRANDS,
            icon: (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="2" y1="12" x2="22" y2="12" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
              </svg>
            ),
          },
          {
            label: "Contact",
            href: ROUTE_PATHS.CONTACT,
            icon: (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.1 19.79 19.79 0 0 1 1.59 4.5 2 2 0 0 1 3.56 2.33h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.18 6.18l.9-.9a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 17.5z" />
              </svg>
            ),
          },
        ].map(({ label, icon, href }) => (
          <Link
            key={label}
            to={href}
            onClick={scrollToTop}
            className="flex-1 flex flex-col items-center justify-center gap-0.5 pt-2 pb-3 text-[10px] font-medium transition-colors text-slate-500 hover:text-blue-400"
          >
            {icon}
            <span>{label}</span>
          </Link>
        ))}
      </nav>

      <div className="sm:hidden h-16" />

      {/* About Description Modal */}
      {aboutOpen && aboutDescription && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center p-4"
          role="dialog"
          aria-modal="true"
          aria-labelledby="footer-about-title"
          onKeyDown={(event) => { if (event.key === "Escape") setAboutOpen(false); }}
        >
          <div
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={() => setAboutOpen(false)}
          />
          <Effects type="modal-enter" className="relative z-10 w-full max-w-xl max-h-[80vh] flex flex-col rounded-2xl bg-[#090d16] border border-blue-900/60 shadow-2xl overflow-hidden text-slate-200">
            <div className="flex items-start justify-between gap-4 px-7 pt-6 pb-4 border-b border-blue-950 bg-[#030712]">
              <h3 id="footer-about-title" className="text-xl font-semibold tracking-wide text-blue-400">
                About Us
              </h3>
              <button
                type="button"
                onClick={() => setAboutOpen(false)}
                aria-label="Close"
                autoFocus
                className="flex-shrink-0 -mr-1.5 -mt-1 p-1.5 rounded-full text-slate-400 hover:text-blue-400 hover:bg-blue-500/10 transition-colors"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
            <div className="overflow-y-auto px-7 py-6 space-y-4">
              {description
                .split(/\n+/)
                .filter((p) => p.trim())
                .map((paragraph, i) => (
                  <p
                    key={i}
                    className={`text-[15px] leading-[1.8] tracking-[0.01em] ${i === 0 ? "text-blue-300 font-medium" : "text-slate-400"}`}
                  >
                    {paragraph}
                  </p>
                ))}
            </div>
          </Effects>
        </div>
      )}
    </footer>
  );
};